/**
 * Sweet little script for loading the modules files automagically
 */

import { camelCase } from "lodash";

const files = require.context(".", false, /\.ts$/);
const modules = {};

files.keys().forEach((fileName) => {
	if (fileName === "./index.ts") {
		return;
	}
	const moduleName = camelCase(fileName.replace(/(\.\/|\.ts)/g, ""));
	modules[moduleName] = files(fileName).default;
});

export default modules;
